/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * AIActivity
 */
export interface AIActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'AI';

  /**
   * Title
   */
  title: string;

  /**
   * Description
   */
  description: string;

  /**
   * Items
   */
  items: AIItem[];

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * AIAnswerDetailResponse
 */
export interface AIAnswerDetailResponse {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Question
   */
  question: string;

  /**
   * Answer
   */
  answer: string;

  /**
   * Confidence
   */
  confidence: number;

  feedback: AnswerFeedback | null;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;

  /**
   * Updated At
   *
   * @format date-time
   */
  updated_at: string;

  /**
   * References
   */
  references?: FactResponse[] | null;
}

/**
 * AIAnswerListItem
 */
export interface AIAnswerListItem {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Question
   */
  question: string;

  /**
   * Answer
   */
  answer: string | null;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;
}

/**
 * AIItem
 */
export interface AIItem {
  /**
   * Id
   */
  id: string;

  /**
   * Title
   */
  title: string;

  /**
   * Description
   */
  description: string;
}

/**
 * AccessRequestDisplay
 */
export interface AccessRequestDisplay {
  /**
   * Id
   */
  id: string;

  /**
   * Contact Name
   */
  contact_name: string;

  /**
   * Company Name
   */
  company_name: string;

  /**
   * Email Address
   */
  email_address: string;

  /**
   * Position
   */
  position: string;

  reason: ContactReason;

  /**
   * Organization Name
   */
  organization_name: string;

  /**
   * Has Been Viewed
   */
  has_been_viewed: boolean;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;

  /**
   * Updated At
   *
   * @format date-time
   */
  updated_at: string;

  status: AccessRequestStatus;

  approver: PartialUser | null;
}

/**
 * AccessRequestStatus
 */
export enum AccessRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

/**
 * AccessTokenRequest
 */
export interface AccessTokenRequest {
  /**
   * Access Request Id
   */
  access_request_id: string;
}

/**
 * AccessTokenResponse
 */
export interface AccessTokenResponse {
  /**
   * Token
   */
  token: string;

  /**
   * Expiration
   */
  expiration: string;
}

/**
 * AnalyticsData
 */
export interface AnalyticsData {
  /**
   * Total Minutes Saved
   */
  total_minutes_saved: number;

  /**
   * Roi Dollars
   */
  roi_dollars: number;

  /**
   * Questionnaires Processed
   */
  questionnaires_processed: number;

  /**
   * Answers Generated
   */
  answers_generated: number;

  /**
   * Answers Over Time
   */
  answers_over_time: Record<string, number>;

  /**
   * Individual Data
   */
  individual_data: IndividualAnalyticsData[];
}

/**
 * AnalyticsResponse
 */
export interface AnalyticsResponse {
  /**
   * All Time Roi Dollars
   */
  all_time_roi_dollars: number;

  monthly_data: AnalyticsData;

  yearly_data: AnalyticsData;
}

/**
 * AnswerFeedback
 */
export enum AnswerFeedback {
  THUMBS_UP = 'THUMBS_UP',
  THUMBS_DOWN = 'THUMBS_DOWN',
}

/**
 * AnswerFeedbackRequest
 */
export interface AnswerFeedbackRequest {
  /**
   * Ai Answer Id
   */
  ai_answer_id: string;

  feedback?: AnswerFeedback | null;
}

/**
 * AnswerFieldResponse
 */
export interface AnswerFieldResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  field_type: DQAnswerFieldType;

  /**
   * Row Location
   */
  row_location: number;

  /**
   * Column Location
   */
  column_location: string;

  /**
   * Multiple Choice Options
   */
  multiple_choice_options: string[] | null;

  current_answer: AnswerHistoryResponse | null;

  /**
   * Answer History
   */
  answer_history: AnswerHistoryResponse[];
}

/**
 * AnswerHistoryResponse
 */
export interface AnswerHistoryResponse {
  /**
   * Version
   */
  version: number;

  /**
   * Answer Text
   */
  answer_text: string;

  /**
   * Confidence Score
   */
  confidence_score: number | null;

  /**
   * Answered At
   *
   * @format date-time
   */
  answered_at: string;

  review_status: ReviewStatus;

  reviewed_by: ProfileInfo | null;

  last_modified_by: ProfileInfo;

  /**
   * Last Modified At
   *
   * @format date-time
   */
  last_modified_at: string;

  /**
   * Facts
   */
  facts: FactResponse[];
}

/**
 * AnswerUpdateActivity
 */
export interface AnswerUpdateActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'AnswerUpdate';

  /**
   * Oldanswer
   */
  oldAnswer: string;

  /**
   * Newanswer
   */
  newAnswer: string;

  /**
   * Changesummary
   */
  changeSummary: string;

  updatedBy: Person;

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * ApproveAnswerRequest
 */
export interface ApproveAnswerRequest {
  /**
   * Question Id
   *
   * @format uuid
   */
  question_id: string;

  /**
   * Approved
   */
  approved: boolean;
}

/**
 * ApproveAnswerResponse
 */
export interface ApproveAnswerResponse {
  /**
   * Message
   */
  message: string;

  review_status: ReviewStatus;
}

/**
 * AssignDocumentRequest
 */
export interface AssignDocumentRequest {
  /**
   * Assigned User Id
   */
  assigned_user_id?: string | null;
}

/**
 * AssignedActivity
 */
export interface AssignedActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'Assigned';

  assignedBy: Person;

  assignedTo: Person | null;

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * AutofillDocumentQuestion
 */
export interface AutofillDocumentQuestion {
  /**
   * Id
   */
  id: string;

  /**
   * Question
   */
  question: string;

  /**
   * Main Answer
   */
  main_answer: string | null;

  /**
   * Approved
   */
  approved: boolean;

  /**
   * Needs Attention
   */
  needs_attention: boolean;

  /**
   * Confidence Score
   */
  confidence_score: number | null;
}

/**
 * AutofillDocumentQuestionDetailResponse
 */
export interface AutofillDocumentQuestionDetailResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Question
   */
  question: string;

  /**
   * Main Answer
   */
  main_answer?: string | null;

  /**
   * Facts
   */
  facts?: FactResponse[] | null;

  /**
   * Secondary Answers
   *
   * @default []
   */
  secondary_answers?: SecondaryAnswerResponse[];

  /**
   * Confidence Score
   */
  confidence_score?: number | null;

  /**
   * Approved
   */
  approved: boolean;
}

/**
 * AutofillDocumentQuestionsResponse
 */
export interface AutofillDocumentQuestionsResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Sheets
   */
  sheets: AutofillDocumentSheetQuestionsResponse[];
}

/**
 * AutofillDocumentResponse
 */
export interface AutofillDocumentResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  assignee: UserResponse | null;

  /**
   * Status
   */
  status: string;

  /**
   * Deadline
   */
  deadline: string | null;

  /**
   * Document Type
   */
  document_type: string;

  /**
   * Response Style
   */
  response_style: string | null;

  /**
   * Deal Value
   */
  deal_value: number | null;

  /**
   * Custom Instructions
   */
  custom_instructions: string | null;

  /**
   * Total Questions
   */
  total_questions: number;

  /**
   * Percentage Answered
   */
  percentage_answered: number;

  /**
   * Num Ai Answers
   */
  num_ai_answers: number;

  /**
   * Num High Conf Answers
   */
  num_high_conf_answers: number;

  /**
   * Num Manual Answers
   */
  num_manual_answers: number;

  /**
   * Sheets
   */
  sheets: AutofillSheetResponse[];

  /**
   * Estimated Time Remaining
   */
  estimated_time_remaining?: number | null;
}

/**
 * AutofillDocumentSheetQuestionsResponse
 */
export interface AutofillDocumentSheetQuestionsResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Number
   */
  number: number;

  /**
   * Questions
   */
  questions: AutofillDocumentQuestion[];
}

/**
 * AutofillSheetResponse
 */
export interface AutofillSheetResponse {
  /**
   * Name
   */
  name: string;

  /**
   * Number
   */
  number: number;

  /**
   * Total Questions
   */
  total_questions: number;

  /**
   * Percentage Answered
   */
  percentage_answered: number;

  /**
   * Num Ai Answers
   */
  num_ai_answers: number;

  /**
   * Num High Conf Answers
   */
  num_high_conf_answers: number;

  /**
   * Num Manual Answers
   */
  num_manual_answers: number;
}

/**
 * Body_upload_file_for_autofill
 */
export interface BodyUploadFileForAutofill {
  /**
   * File
   *
   * @format binary
   */
  file: File;

  document_type: DQDocumentType;

  /**
   * Deal Size
   */
  deal_size?: number | null;

  /**
   * Deadline
   */
  deadline?: string | null;

  /**
   * Instruction
   */
  instruction?: string | null;

  /**
   * Style Guide Id
   */
  style_guide_id?: string | null;
}

/**
 * Body_upload_file_for_parsing
 */
export interface BodyUploadFileForParsing {
  /**
   * Files
   */
  files: File[];
}

/**
 * CarbonAuthResponse
 */
export interface CarbonAuthResponse {
  /**
   * Access Token
   */
  access_token: string;

  /**
   * Refresh Token
   */
  refresh_token: string;
}

/**
 * ChangeDocumentStatusRequest
 */
export interface ChangeDocumentStatusRequest {
  new_status: DQDocumentStatus;
}

/**
 * CommentActivity
 */
export interface CommentActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'Comment';

  author: Person;

  /**
   * Content
   */
  content: string;

  /**
   * Peopletags
   */
  peopleTags: Person[];

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * CompanyContent
 */
export interface CompanyContent {
  /**
   * Organization Id
   */
  organization_id: string;

  /**
   * Company Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  company_url: string;

  /**
   * Company Name
   */
  company_name: string;

  /**
   * Company Fav Icon
   */
  company_fav_icon?: string | null;

  /**
   * Is Access Enabled
   */
  is_access_enabled: boolean;

  header: Header;

  /**
   * Resources
   */
  resources: ResourceModel[];

  /**
   * Sub Processors
   */
  sub_processors?: SubProcessor[] | null;

  ai_model_architecture: Section;

  ai_model_use: Section;

  data_use_training: Section;

  data_use_inference: Section;

  /**
   * Controls
   */
  controls: ControlCategory[];

  /**
   * Iso Controls
   */
  iso_controls?: ISOControlCategory[] | null;
}

/**
 * ContactReason
 */
export enum ContactReason {
  EXISTING_CUSTOMER = 'EXISTING_CUSTOMER',
  PROSPECTIVE_CUSTOMER = 'PROSPECTIVE_CUSTOMER',
  OTHER = 'OTHER',
}

/**
 * ContentSourceType
 */
export enum ContentSourceType {
  FILE_UPLOAD = 'FILE_UPLOAD',
  WEBSITE_CRAWL = 'WEBSITE_CRAWL',
  INTEGRATION = 'INTEGRATION',
}

/**
 * ContentStatus
 */
export enum ContentStatus {
  YET_TO_START = 'YET_TO_START',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

/**
 * ControlCategory
 */
export interface ControlCategory {
  /**
   * Category
   */
  category: string;

  /**
   * Items
   */
  items: ControlItem[];

  /**
   * Is Ai Specific
   */
  is_ai_specific: boolean;
}

/**
 * ControlItem
 */
export interface ControlItem {
  /**
   * Name
   */
  name: string;

  /**
   * Summary
   */
  summary: string;

  /**
   * Status
   */
  status: boolean;
}

/**
 * ConversationResponse
 *
 * Response model for conversation history
 */
export interface ConversationResponse {
  /**
   * Agent Name
   */
  agent_name: string;

  /**
   * Agent Profile Image
   */
  agent_profile_image: string | null;

  /**
   * Messages
   */
  messages: AgentAgentEndpointsMessageResponse[];
}

/**
 * CreateCommentRequest
 */
export interface CreateCommentRequest {
  /**
   * Content
   */
  content: string;

  /**
   * Peopletags
   */
  peopleTags?: string[] | null;
}

/**
 * DQAnswerFieldType
 */
export enum DQAnswerFieldType {
  STRING = 'STRING',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
}

/**
 * DQDocumentResponse
 */
export interface DQDocumentResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Download Url
   */
  download_url: string;

  status: DQDocumentStatus;

  document_type: DQDocumentType;

  /**
   * Num Of Questions
   */
  num_of_questions: number;

  /**
   * Answered Questions
   */
  answered_questions: number;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;

  /**
   * Updated At
   *
   * @format date-time
   */
  updated_at: string;

  /**
   * Deadline
   */
  deadline: string | null;

  /**
   * Deal Size
   */
  deal_size: number | null;

  /**
   * Instruction
   */
  instruction: string | null;
}

/**
 * DQDocumentStatus
 */
export enum DQDocumentStatus {
  YET_TO_START = 'YET_TO_START',
  QUESTION_EXTRACTION_IN_PROGRESS = 'QUESTION_EXTRACTION_IN_PROGRESS',
  QUESTION_EXTRACTION_COMPLETED = 'QUESTION_EXTRACTION_COMPLETED',
  QUESTION_EXTRACTION_FAILED = 'QUESTION_EXTRACTION_FAILED',
  ANSWERING_IN_PROGRESS = 'ANSWERING_IN_PROGRESS',
  ANSWERING_COMPLETED = 'ANSWERING_COMPLETED',
  USER_ACCEPTED_ANSWER = 'USER_ACCEPTED_ANSWER',
  ANSWERING_FAILED = 'ANSWERING_FAILED',
  MARKED_AS_DELETED = 'MARKED_AS_DELETED',
}

/**
 * DQDocumentType
 */
export enum DQDocumentType {
  RFI = 'RFI',
  RFP = 'RFP',
  SECURITY_QUESTIONNAIRE = 'SECURITY_QUESTIONNAIRE',
  UNCATEGORIZED = 'UNCATEGORIZED',
}

/**
 * DQDocumentsResponse
 */
export interface DQDocumentsResponse {
  /**
   * Documents
   */
  documents: DQDocumentResponse[];
}

/**
 * ExtensionTokenResponse
 */
export interface ExtensionTokenResponse {
  /**
   * Access Token
   */
  access_token: string;

  /**
   * Token Type
   *
   * @default "bearer"
   */
  token_type?: string;
}

/**
 * ExternalIntegrationCreate
 */
export interface ExternalIntegrationCreate {
  /**
   * Provider
   */
  provider: string;

  /**
   * Config
   */
  config: object;
}

/**
 * ExternalIntegrationResponse
 */
export interface ExternalIntegrationResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Provider
   */
  provider: string;

  /**
   * Config
   */
  config: object;

  /**
   * Last Synced At
   */
  last_synced_at: string | null;

  /**
   * Sync Status
   */
  sync_status: string | null;

  /**
   * Created At
   */
  created_at: string;

  /**
   * Updated At
   */
  updated_at: string;
}

/**
 * FactCreate
 */
export interface FactCreate {
  /**
   * Statement
   */
  statement: string;
}

/**
 * FactEdit
 */
export interface FactEdit {
  /**
   * Statement
   */
  statement?: string | null;
}

/**
 * FactResponse
 */
export interface FactResponse {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Content Source Id
   */
  content_source_id?: string | null;

  /**
   * Statement
   */
  statement: string;

  /**
   * Source Content
   */
  source_content?: string | null;

  /**
   * Source Last Modified
   */
  source_last_modified?: string | null;

  /**
   * Source Download Url
   */
  source_download_url?: string | null;

  /**
   * Source Name
   */
  source_name?: string | null;

  source_type?: ContentSourceType | null;

  file_type?: FileUploadType | null;

  status: FactStatus;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;
}

/**
 * FactSourceResponse
 */
export interface FactSourceResponse {
  /**
   * Name
   */
  name: string;

  type: ContentSourceType;

  status: ContentStatus;

  file_type?: FileUploadType | null;

  /**
   * Integration Type
   */
  integration_type?: string | null;

  /**
   * Custom Instructions
   */
  custom_instructions?: string | null;

  /**
   * Facts
   */
  facts: FactResponse[];

  /**
   * Uploaded At
   *
   * @format date-time
   */
  uploaded_at: string;
}

/**
 * FactStatus
 */
export enum FactStatus {
  ACTIVE = 'ACTIVE',
  IN_REVIEW = 'IN_REVIEW',
  DEPRECATED = 'DEPRECATED',
}

/**
 * FileUploadProgressResponse
 */
export interface FileUploadProgressResponse {
  /**
   * Num Of Files
   */
  num_of_files: number;

  /**
   * Total Chunks
   */
  total_chunks: number;

  /**
   * Completed Chunks
   */
  completed_chunks: number;

  /**
   * In Progress Chunks
   */
  in_progress_chunks: number;

  /**
   * Time Remaining In Secs
   */
  time_remaining_in_secs: number;
}

/**
 * FileUploadType
 */
export enum FileUploadType {
  PARSE_QUESTIONNAIRE = 'PARSE_QUESTIONNAIRE',
  PARSE_POLICY = 'PARSE_POLICY',
  PARSE_CONVERSATION = 'PARSE_CONVERSATION',
  PARSE_PRODUCT = 'PARSE_PRODUCT',
}

/**
 * GenerateAnswerRequest
 */
export interface GenerateAnswerRequest {
  /**
   * Question
   */
  question: string;

  /**
   * Style Guide Id
   */
  style_guide_id?: string | null;
}

/**
 * GenerateAnswerResponse
 */
export interface GenerateAnswerResponse {
  /**
   * Id
   */
  id?: string | null;

  /**
   * Found
   */
  found: boolean;

  /**
   * Answer
   */
  answer: string;

  /**
   * Confidence
   */
  confidence: number;

  /**
   * References
   */
  references: FactResponse[];

  feedback?: AnswerFeedback | null;

  /**
   * Style Guide Id
   */
  style_guide_id?: string | null;
}

/**
 * HTTPValidationError
 */
export interface HTTPValidationError {
  /**
   * Detail
   */
  detail?: ValidationError[];
}

/**
 * Header
 */
export interface Header {
  company_logo: Logo;

  /**
   * Company Description
   */
  company_description: string;

  /**
   * Security Point Of Contact
   */
  security_point_of_contact: string;

  /**
   * Security Email
   */
  security_email: string;

  /**
   * Privacy Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  privacy_url: string;

  /**
   * Terms Of Service Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  terms_of_service_url: string;

  appearance: HeaderAppearance;

  /**
   * Customer Logo Urls
   */
  customer_logo_urls?: Logo[] | null;

  /**
   * Compliance
   */
  compliance?: Logo[] | null;
}

/**
 * HeaderAppearance
 */
export interface HeaderAppearance {
  theme: Theme;

  /**
   * Gradient Start
   */
  gradient_start: string;

  /**
   * Gradient End
   */
  gradient_end: string;
}

/**
 * ISOControlCategory
 */
export interface ISOControlCategory {
  /**
   * Category
   */
  category: string;

  /**
   * Summary
   */
  summary: string;

  /**
   * Items
   */
  items: ISOControlItem[];
}

/**
 * ISOControlItem
 */
export interface ISOControlItem {
  /**
   * Criteria
   */
  criteria: string;

  /**
   * Topic
   */
  topic: string;

  /**
   * Control
   */
  control: string;

  /**
   * Resources
   */
  resources: string[];

  /**
   * Status
   */
  status: boolean;
}

/**
 * IndividualAnalyticsData
 */
export interface IndividualAnalyticsData {
  /**
   * Name
   */
  name: string;

  /**
   * Profile Picture
   */
  profile_picture: string | null;

  /**
   * Answers Generated
   */
  answers_generated: number;

  /**
   * Minutes Saved
   */
  minutes_saved: number;
}

/**
 * InviteUserRequest
 */
export interface InviteUserRequest {
  /**
   * Email
   *
   * @format email
   */
  email: string;
}

/**
 * ListItem
 */
export interface ListItem {
  /**
   * Description
   */
  description: string;

  /**
   * Is Supported
   */
  is_supported: boolean;
}

/**
 * Logo
 */
export interface Logo {
  /**
   * Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string;

  /**
   * Alt
   */
  alt: string;

  /**
   * Height
   */
  height: number;

  /**
   * Width
   */
  width: number;
}

/**
 * MessageRequest
 *
 * Request model for sending a message
 */
export interface MessageRequest {
  /**
   * Message
   */
  message: string;
}

/**
 * OrganizationCreate
 */
export interface OrganizationCreate {
  /**
   * Name
   *
   * @minLength 1
   * @maxLength 100
   */
  name: string;

  /**
   * Image
   */
  image?: string | null;

  /**
   * Hd
   */
  hd?: string | null;
}

/**
 * OrganizationEdit
 */
export interface OrganizationEdit {
  /**
   * Name
   */
  name?: string | null;

  /**
   * Hd
   */
  hd?: string | null;
}

/**
 * OrganizationModel
 */
export interface OrganizationModel {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Hd
   */
  hd?: string | null;
}

/**
 * OrganizationResponse
 */
export interface OrganizationResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Image
   */
  image: string | null;

  /**
   * Hd
   */
  hd: string | null;
}

/**
 * OutputFormat
 */
export enum OutputFormat {
  Docx = 'docx',
  Original = 'original',
  Pdf = 'pdf',
  Xlsx = 'xlsx',
}

/**
 * PaginatedFactResponse
 */
export interface PaginatedFactResponse {
  /**
   * Data
   */
  data: FactResponse[];

  /**
   * Total
   */
  total: number;

  /**
   * Page
   */
  page: number;

  /**
   * Page Size
   */
  page_size: number;

  /**
   * Total Pages
   */
  total_pages: number;
}

/**
 * PartialUser
 */
export interface PartialUser {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Profile Image
   */
  profile_image: string | null;

  /**
   * Username
   */
  username: string | null;
}

/**
 * Person
 */
export interface Person {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Email
   */
  email: string;

  /**
   * Profileimage
   */
  profileImage: string | null;
}

/**
 * PortalAccessRequest
 */
export interface PortalAccessRequest {
  /**
   * Contact Name
   */
  contact_name: string;

  /**
   * Company Name
   */
  company_name?: string | null;

  /**
   * Position
   */
  position?: string | null;

  /**
   * Email Address
   *
   * @format email
   */
  email_address: string;

  reason: ContactReason;

  /**
   * Organization Id
   */
  organization_id: string;
}

/**
 * ProfileInfo
 */
export interface ProfileInfo {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Profile Image
   */
  profile_image: string | null;
}

/**
 * QuestionResponse
 */
export interface QuestionResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Question Text
   */
  question_text: string;

  /**
   * Category
   */
  category: string;

  /**
   * Subcategory
   */
  subcategory: string | null;

  /**
   * Additional Context
   */
  additional_context: string | null;

  /**
   * Row Location
   */
  row_location: number;

  /**
   * Column Location
   */
  column_location: string;

  /**
   * Answer Fields
   */
  answer_fields: AnswerFieldResponse[];
}

/**
 * RegenerateAnswerRequest
 */
export interface RegenerateAnswerRequest {
  /**
   * Existing Answer
   */
  existing_answer?: string | null;

  /**
   * Custom Instructions
   */
  custom_instructions?: string | null;

  /**
   * Style Guide Id
   */
  style_guide_id?: string | null;
}

/**
 * RegenerateFactsRequest
 */
export interface RegenerateFactsRequest {
  /**
   * Content Id
   */
  content_id: string;

  /**
   * Instruction
   */
  instruction: string;
}

/**
 * RegeneratedActivity
 */
export interface RegeneratedActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'Regenerated';

  regeneratedBy: Person;

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;

  /**
   * Instructions
   */
  instructions: string | null;
}

/**
 * RenameDocumentRequest
 */
export interface RenameDocumentRequest {
  /**
   * Name
   */
  name: string;
}

/**
 * ResourceModel
 */
export interface ResourceModel {
  /**
   * Type
   */
  type: string;

  /**
   * Title
   */
  title: string;

  /**
   * Description
   */
  description: string;

  /**
   * Is Public
   */
  is_public: boolean;

  /**
   * Url
   */
  url?: string | null;
}

/**
 * Response
 */
export interface Response {
  /**
   * Message
   */
  message: string;
}

/**
 * ReviewStatus
 */
export enum ReviewStatus {
  NOT_REVIEWED = 'NOT_REVIEWED',
  REVIEWED = 'REVIEWED',
}

/**
 * SecondaryAnswerResponse
 */
export interface SecondaryAnswerResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Answer
   */
  answer: string;

  /**
   * Constraints
   */
  constraints?: string[] | null;
}

/**
 * Section
 */
export interface Section {
  /**
   * Title
   */
  title?: string | null;

  /**
   * Summary
   */
  summary?: string | null;

  /**
   * Logos
   *
   * @default []
   */
  logos?: Logo[];

  /**
   * Items
   *
   * @default []
   */
  items?: ListItem[];

  /**
   * Is Verified
   *
   * @default false
   */
  is_verified?: boolean;
}

/**
 * SheetResponse
 */
export interface SheetResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Number
   */
  number: number;

  /**
   * Questions
   */
  questions: QuestionResponse[];
}

/**
 * Source
 */
export interface Source {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Progress
   */
  progress: number;

  type: ContentSourceType;

  status: ContentStatus;

  /**
   * Download Url
   */
  download_url?: string | null;

  /**
   * Url
   */
  url?: string | null;

  file_type?: FileUploadType | null;

  /**
   * Uploaded At
   *
   * @format date-time
   */
  uploaded_at: string;
}

/**
 * Standard
 */
export enum Standard {
  ISO42001 = 'ISO-42001',
  NISTAI = 'NIST-AI',
  CCPA = 'CCPA',
  SOC2 = 'SOC2',
  ISO27001 = 'ISO-27001',
  OWASP = 'OWASP',
  GDPR = 'GDPR',
  HIPAA = 'HIPAA',
  FedRAMP = 'FedRAMP',
  PCIDSS = 'PCI-DSS',
}

/**
 * StyleGuideInput
 */
export interface StyleGuideInput {
  /**
   * Name
   */
  name: string;

  /**
   * Description
   */
  description: string;

  /**
   * Body
   */
  body: string;
}

/**
 * StyleGuideModel
 */
export interface StyleGuideModel {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Name
   */
  name: string;

  /**
   * Description
   */
  description: string;

  /**
   * Body
   */
  body: string;

  /**
   * Is Default
   *
   * @default false
   */
  is_default?: boolean | null;
}

/**
 * StyleGuideResponse
 */
export interface StyleGuideResponse {
  guide: StyleGuideModel;
}

/**
 * StyleGuidesResponse
 */
export interface StyleGuidesResponse {
  /**
   * Guides
   */
  guides: StyleGuideModel[];
}

/**
 * SubProcessor
 */
export interface SubProcessor {
  /**
   * Name
   */
  name: string;

  /**
   * Purpose
   */
  purpose: string;

  /**
   * Location
   */
  location: string[];

  logo: Logo;

  /**
   * Standards
   */
  standards?: Standard[] | null;
}

/**
 * SuggestedQuestionsResponse
 */
export interface SuggestedQuestionsResponse {
  /**
   * Questions
   */
  questions: string[];
}

/**
 * TestStyleGuideInput
 */
export interface TestStyleGuideInput {
  /**
   * Question
   */
  question: string;
}

/**
 * TestStyleGuideOutput
 */
export interface TestStyleGuideOutput {
  /**
   * Style Id
   *
   * @format uuid
   */
  style_id: string;

  /**
   * Answer
   */
  answer: string;
}

/**
 * TestStyleGuidesResponse
 */
export interface TestStyleGuidesResponse {
  /**
   * Results
   */
  results: TestStyleGuideOutput[];
}

/**
 * Theme
 */
export enum Theme {
  Light = 'light',
  Dark = 'dark',
}

/**
 * UpdateAnswerRequest
 */
export interface UpdateAnswerRequest {
  /**
   * Answer Text
   */
  answer_text: string;

  review_status?: ReviewStatus | null;
}

/**
 * UpdateAnswerResponse
 */
export interface UpdateAnswerResponse {
  /**
   * Message
   */
  message: string;

  current_answer: AnswerHistoryResponse;

  /**
   * Answer History
   */
  answer_history: AnswerHistoryResponse[];
}

/**
 * UpdateCommentRequest
 */
export interface UpdateCommentRequest {
  /**
   * Content
   */
  content?: string | null;

  /**
   * Peopletags
   */
  peopleTags?: string[] | null;
}

/**
 * UpdateDQDocumentRequest
 */
export interface UpdateDQDocumentRequest {
  /**
   * Assigned User Id
   */
  assigned_user_id?: string | null;

  /**
   * Name
   */
  name?: string | null;

  /**
   * Deadline
   */
  deadline?: string | null;

  /**
   * Deal Size
   */
  deal_size?: number | null;

  /**
   * Instruction
   */
  instruction?: string | null;

  /**
   * Style Guide Id
   */
  style_guide_id?: string | null;
}

/**
 * UpdateQuestionReviewStatusRequest
 */
export interface UpdateQuestionReviewStatusRequest {
  review_status: ReviewStatus;
}

/**
 * UpdateQuestionReviewStatusResponse
 */
export interface UpdateQuestionReviewStatusResponse {
  /**
   * Message
   */
  message: string;

  review_status: ReviewStatus;
}

/**
 * UpdatedActivity
 */
export interface UpdatedActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'Updated';

  updatedBy: Person;

  /**
   * Updatedfield
   */
  updatedField: string;

  /**
   * Oldvalue
   */
  oldValue: null;

  /**
   * Newvalue
   */
  newValue: null;

  /**
   * Changesummary
   */
  changeSummary: null;

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * UploadedActivity
 */
export interface UploadedActivity {
  /**
   * Id
   */
  id: string;

  /**
   * Type
   */
  type: 'Uploaded';

  uploadedBy: Person;

  /**
   * Documentname
   */
  documentName: string;

  /**
   * Timestamp
   *
   * @format date-time
   */
  timestamp: string;
}

/**
 * UrlSelectionRequest
 */
export interface UrlSelectionRequest {
  /**
   * Job Id
   */
  job_id: string;

  /**
   * Selected Urls
   */
  selected_urls: string[];

  /**
   * Org Id
   */
  org_id?: string | null;

  /**
   * Original Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  original_url: string;
}

/**
 * UrlSelectionResponse
 */
export interface UrlSelectionResponse {
  /**
   * Status
   */
  status: string;

  /**
   * Message
   */
  message: string;

  /**
   * Urls
   */
  urls: string[];
}

/**
 * UserEdit
 */
export interface UserEdit {
  /**
   * Name
   */
  name?: string | null;

  /**
   * Email
   */
  email?: string | null;

  /**
   * Username
   */
  username?: string | null;
}

/**
 * UserResponse
 */
export interface UserResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Email
   */
  email: string;

  /**
   * Name
   */
  name: string;

  /**
   * Username
   */
  username: string | null;

  status: UserStatus;

  /**
   * Profile Image
   */
  profile_image: string | null;

  /**
   * Organization Id
   */
  organization_id: string | null;

  /**
   * Organization Name
   */
  organization_name: string | null;

  /**
   * Organization Domain
   */
  organization_domain: string | null;

  /**
   * Is Internal
   */
  is_internal: boolean;

  /**
   * Has Trust Center
   */
  has_trust_center: boolean;
}

/**
 * UserStatus
 */
export enum UserStatus {
  ONBOARDING_CREATE_ORG = 'ONBOARDING_CREATE_ORG',
  ONBOARDING_ADD_SOURCES = 'ONBOARDING_ADD_SOURCES',
  ONBOARDING_ASK_QUESTION = 'ONBOARDING_ASK_QUESTION',
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
}

/**
 * UserUpdatedAnswerRequest
 */
export interface UserUpdatedAnswerRequest {
  /**
   * Ai Answer Id
   */
  ai_answer_id: string;

  /**
   * User Updated Answer
   */
  user_updated_answer: string;
}

/**
 * ValidationError
 */
export interface ValidationError {
  /**
   * Location
   */
  loc: (string | number)[];

  /**
   * Message
   */
  msg: string;

  /**
   * Error Type
   */
  type: string;
}

/**
 * WebsiteCrawlRequest
 */
export interface WebsiteCrawlRequest {
  /**
   * Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  url: string;
}

/**
 * WebsiteCrawlResponse
 */
export interface WebsiteCrawlResponse {
  /**
   * Job Id
   */
  job_id: string;

  /**
   * Message
   */
  message: string;

  /**
   * Original Url
   *
   * @format uri
   * @minLength 1
   * @maxLength 2083
   */
  original_url: string;
}

/**
 * MessageResponse
 *
 * Response model for messages
 */
export interface AgentAgentEndpointsMessageResponse {
  /**
   * Id
   *
   * @format uuid
   */
  id: string;

  /**
   * Content
   */
  content: string;

  /**
   * Sender Name
   */
  sender_name: string;

  /**
   * Sender Profile Image
   */
  sender_profile_image: string | null;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;
}

/**
 * QuestionnaireResponse
 */
export interface InferenceAutofillQuestionnaireResponse {
  /**
   * Id
   */
  id: string;

  /**
   * Name
   */
  name: string;

  status: DQDocumentStatus;

  document_type: DQDocumentType;

  /**
   * Created At
   *
   * @format date-time
   */
  created_at: string;

  /**
   * Updated At
   *
   * @format date-time
   */
  updated_at: string;

  /**
   * Deadline
   */
  deadline: string | null;

  /**
   * Deal Size
   */
  deal_size: number | null;

  /**
   * Instruction
   */
  instruction: string | null;

  /**
   * Global Instructions
   */
  global_instructions: string | null;

  /**
   * Sheets
   */
  sheets: SheetResponse[];

  /**
   * Total Questions
   */
  total_questions: number;

  /**
   * Answered Questions
   */
  answered_questions: number;
}

/**
 * QuestionnaireResponse
 */
export interface ParsingEndpointQuestionnaireResponse {
  /**
   * File Id
   */
  file_id: string;

  /**
   * Message
   */
  message: string;
}

/**
 * MessageResponse
 */
export interface UsersPreferencesEndpointMessageResponse {
  /**
   * Message
   */
  message: string;
}
